import mod from "-!./AddressForm.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./AddressForm.js?vue&type=script&lang=js&external"